export default obj => Object.keys(obj).map(key => obj[key]);
